// 全体の親
import FirstOrder from "@/pages/firstOrder/Index";

// 仮申込
import TmpOrder from "@/pages/firstOrder/TmpOrder";
import DoneTmpOrder from "@/pages/firstOrder/DoneTmpOrder";

// お申し込み内容入力
import SelectPlan from "@/pages/firstOrder/SelectPlan"
import CustomerInfo from "@/pages/firstOrder/CustomerInfo";
import InputServiceContents from "@/pages/firstOrder/InputServiceContents";
import ConfirmFirstOrder from "@/pages/firstOrder/ConfirmFirstOrder";
import FinishFirstOrder from "@/pages/firstOrder/FinishFirstOrder";

// システムエラー
import SystemError from "@/pages/SystemError";

export default {
  path: "/first_order/",
  component: FirstOrder,
  meta: {
    isFirstOrder: true
  },
  children: [
    {
      path: "tmp_order",
      name: "TmpOrder",
      component: TmpOrder,
      meta: {
        tmpOrder: true,
        title: '仮登録 - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
        description: '仮登録はこちらから。 - desknet\'s NEO・ChatLuck（クラウド版）のサポートサイトです。当サイトでは、お客様情報・ご契約数・オプションサービス・お支払い方法のご確認・ご変更が可能です。',
      },
      props: true,
    },
    {
      path: "done_tmp_order",
      name: "DoneTmpOrder",
      component: DoneTmpOrder,
      meta: {
        tmpOrder: true,
        title: '仮登録 - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      },
      props: true,
    },
    {
      path: "select_plan",
      name: "SelectPlan",
      component: SelectPlan,
      meta: {
        activeStep: "plan",
        title: '本登録 - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      },
      props: true,
    },
    {
      path: "customer_info",
      name: "FirstOrderCustomerInfo",
      component: CustomerInfo,
      meta: {
        activeStep: "customer",
        title: '本登録 - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      },
      props: true,
    },
    {
      path: "input_service_contents",
      name: "InputServiceContents",
      component: InputServiceContents,
      meta: {
        activeStep: "neo",
        title: '本登録 - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      },
      props: true,
    },
    {
      path: "confirm_first_order",
      name: "ConfirmFirstOrder",
      component: ConfirmFirstOrder,
      meta: {
        activeStep: "confirm",
        title: '本登録 - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      },
      props: true,
    },
    {
      path: "finish_first_order",
      name: "FinishFirstOrder",
      component: FinishFirstOrder,
      meta: {
        activeStep: "finish",
        title: '本登録 - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      },
      props: true,
    },
    {
      // 仮申込のシステムエラー
      path: "tmp_system_error",
      name: "TmpSystemError",
      component: SystemError,
      meta: {
        noindex: true,
        title: 'エラー - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      },
      props: true
    },
    {
      // システムエラー
      path: "system_error",
      name: "FirstOrderSystemError",
      component: SystemError,
      meta: {
        activeStep: "true",
        noindex: true,
        title: 'エラー - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      },
      props: true
    }
  ]
}
